import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';

const styles = css`
  margin: 30px 0;
  @media (min-width: 992px) {
    margin: 90px 0 -75px 0;
  }
  .SectionIntroBanner {
    padding: 90px 0 30px 0;
    position: relative;
    background-color: ${colors.brand6};
    background-image: url('/images/pattern-01-dark.svg');
    background-size: 110% auto;
    background-position: center center;
    @media (min-width: 992px) {
      padding: 120px 0 90px 0;
    }
  }
  .SectionIntroBanner_iconGraphic {
    width: 90px;
    height: 90px;
    background-color: ${colors.white};
    border-radius: 50%;
    border: 8px solid ${colors.brand2};
    position: absolute;
    z-index: 3;
    left: 50%;
    top: -45px;
    transform: translateX(-50%);
    background-size: auto 60px;
    background-position: center center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      width: 140px;
      height: 140px;
      top: -70px;
      background-size: auto 70px;
    }
  }
  .SectionIntroBanner_inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 15px;
  }
  .SectionIntroBanner_heading {
    text-align: center;
    position: relative;
    z-index: 3;
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 125px;
      height: 2px;
      background-color: ${colors.brand2};
      margin: 30px auto;
    }
  }
  .SectionIntroBanner_headline {
    font-size: 30px;
    line-height: 1.2;
    font-family: ${typography.Serif};
    font-weight: 600;
    display: block;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 50px;
      max-width: 1000px;
    }
  }
  .SectionIntroBanner_text {
    max-width: 1000px;
  }
  .SectionIntroBanner_text p {
    text-align: center;
    @media (min-width: 992px) {
    }
  }
`;

function SectionIntroBanner({ content }) {
  return (
    <div className={styles}>
      <div className="SectionIntroBanner">
        {
          get(content, '[0].icon.contentUrl') &&
          <div className="SectionIntroBanner_iconGraphic" style={{ backgroundImage: `url(${get(content[0], 'icon.contentUrl')})` }} />
        }
        <div className="container">
          <div className="SectionIntroBanner_inner">
            <h2 className="SectionIntroBanner_heading">
              {
                get(content, '[0].headline') &&
                <span className="SectionIntroBanner_headline">{get(content, '[0].headline')}</span>
              }
            </h2>
            <div className="SectionIntroBanner_text" dangerouslySetInnerHTML={SanitizeHtml(get(content[0], 'text'))} />
          </div>
        </div>
      </div>
    </div>
  );
}

SectionIntroBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SectionIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/SectionIntroBanner.section.js